import MockWifi from './MockWifi';

export default MockWifi;
